import browseApplication from './desktop/frontend/application';

browseApplication.initialize();
